module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "base-info"
  }, [_c('div', {
    staticClass: "base-items"
  }, [_c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("应聘学科/岗位:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.gangWei),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "gangWei", $$v)
      },
      expression: "currentObject.gangWei"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "语文",
      "value": "语文"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "数学",
      "value": "数学"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "英语",
      "value": "英语"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "物理",
      "value": "物理"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "化学",
      "value": "化学"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "生物",
      "value": "生物"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "政治",
      "value": "政治"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "历史",
      "value": "历史"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "地理",
      "value": "地理"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "心理",
      "value": "心理"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "音乐",
      "value": "音乐"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "体育",
      "value": "体育"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "美术",
      "value": "美术"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "科学",
      "value": "科学"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "信息技术(网络工程、计算机科学与技术专业优先)",
      "value": "信息技术"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "通用技术",
      "value": "通用技术"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "物理实验员",
      "value": "物理实验员"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "化学实验员",
      "value": "化学实验员"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "生物实验员",
      "value": "生物实验员"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "卫生与健康教育(医学专业)",
      "value": "卫生与健康教育"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("申请任教学段:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.teachStage),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "teachStage", $$v)
      },
      expression: "currentObject.teachStage"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "高中",
      "value": "高中"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "初中",
      "value": "初中"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小学",
      "value": "小学"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.name),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "name", $$v)
      },
      expression: "currentObject.name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("性别:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.sex),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "sex", $$v)
      },
      expression: "currentObject.sex"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "男",
      "value": "男"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "女",
      "value": "女"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("民族:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.nation),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "nation", $$v)
      },
      expression: "currentObject.nation"
    }
  }, _vm._l((_vm.nations), function(nation) {
    return _c('el-option', {
      key: nation,
      attrs: {
        "label": nation,
        "value": nation
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("身份证号:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.idCard),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "idCard", $$v)
      },
      expression: "currentObject.idCard"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("出生日期:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.birthday),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "birthday", $$v)
      },
      expression: "currentObject.birthday"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("手机号:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.phone),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "phone", $$v)
      },
      expression: "currentObject.phone"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("是否在编:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.zaiBian),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "zaiBian", $$v)
      },
      expression: "currentObject.zaiBian"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": "是"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("是否在职:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.zaiZhi),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "zaiZhi", $$v)
      },
      expression: "currentObject.zaiZhi"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": "是"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("计算机等级:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.currentObject.computerGrade),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "computerGrade", $$v)
      },
      expression: "currentObject.computerGrade"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一级",
      "value": "一级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二级",
      "value": "二级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三级",
      "value": "三级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四级",
      "value": "四级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "其他"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("政治面貌:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必选"
    },
    model: {
      value: (_vm.currentObject.zhengZhi),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "zhengZhi", $$v)
      },
      expression: "currentObject.zhengZhi"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("籍贯:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.jiGuan),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "jiGuan", $$v)
      },
      expression: "currentObject.jiGuan"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("身高:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.height),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "height", $$v)
      },
      expression: "currentObject.height"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("家庭地址:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.currentObject.homeAddress),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "homeAddress", $$v)
      },
      expression: "currentObject.homeAddress"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("本科毕业时间:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.benKeTime),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "benKeTime", $$v)
      },
      expression: "currentObject.benKeTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("研究生毕业时间:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.yanJiuTime),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "yanJiuTime", $$v)
      },
      expression: "currentObject.yanJiuTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("博士生毕业时间:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "size": "small"
    },
    model: {
      value: (_vm.currentObject.boShiTime),
      callback: function($$v) {
        _vm.$set(_vm.currentObject, "boShiTime", $$v)
      },
      expression: "currentObject.boShiTime"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "base-info"
  }, [_c('div', {
    staticClass: "base-items",
    staticStyle: {
      "margin": "50px"
    }
  }, [_c('div', [_vm._v("照片")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    staticStyle: {
      "margin-left": "20px",
      "border": "1px dashed #d9d9d9"
    },
    attrs: {
      "action": "/api/file/upload",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "headers": _vm.headers
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "max-width": "200px",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)]), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("教育背景")]), _vm._v(" "), _c('div', {
    staticClass: "base-info"
  }, [_c('div', {
    staticClass: "base-items"
  }, [_c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("毕业院校:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.eduInfo.biYeSchool),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "biYeSchool", $$v)
      },
      expression: "eduInfo.biYeSchool"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("学历:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.xueLi),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "xueLi", $$v)
      },
      expression: "eduInfo.xueLi"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("专业:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.zhuanYe),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "zhuanYe", $$v)
      },
      expression: "eduInfo.zhuanYe"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("本科毕业院校:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "必填"
    },
    model: {
      value: (_vm.eduInfo.benkeSchool),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "benkeSchool", $$v)
      },
      expression: "eduInfo.benkeSchool"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("本科专业:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.benkezhuanYe),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "benkezhuanYe", $$v)
      },
      expression: "eduInfo.benkezhuanYe"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("是否师范类毕业生:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.shiFanSheng),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "shiFanSheng", $$v)
      },
      expression: "eduInfo.shiFanSheng"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": "是"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("是否应届毕业生:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.yingJieSheng),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "yingJieSheng", $$v)
      },
      expression: "eduInfo.yingJieSheng"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": "是"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("毕业年月:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.biYeTime),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "biYeTime", $$v)
      },
      expression: "eduInfo.biYeTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("研究、博士生毕业院校:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.boShiSchool),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "boShiSchool", $$v)
      },
      expression: "eduInfo.boShiSchool"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("研究、博士生专业:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.boShiZhuanYe),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "boShiZhuanYe", $$v)
      },
      expression: "eduInfo.boShiZhuanYe"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("英语等级:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.englishLevel),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "englishLevel", $$v)
      },
      expression: "eduInfo.englishLevel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "四级",
      "value": "四级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "六级",
      "value": "六级"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "专四",
      "value": "专四"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "专八",
      "value": "专八"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "其他"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("平均学分绩点:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.avgScore),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "avgScore", $$v)
      },
      expression: "eduInfo.avgScore"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("综合排名:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.zongHeOrder),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "zongHeOrder", $$v)
      },
      expression: "eduInfo.zongHeOrder"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("参与排名人数:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "orderNumber", $$v)
      },
      expression: "eduInfo.orderNumber"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("普通话等级:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.chineseLevel),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "chineseLevel", $$v)
      },
      expression: "eduInfo.chineseLevel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一甲",
      "value": "一甲"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一乙",
      "value": "一乙"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二甲",
      "value": "二甲"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二乙",
      "value": "二乙"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二级以下",
      "value": "二级以下"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("专业技术职称:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.zhuanYeZhiCheng),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "zhuanYeZhiCheng", $$v)
      },
      expression: "eduInfo.zhuanYeZhiCheng"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "无"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正高级教师",
      "value": "正高级教师"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "高级教师",
      "value": "高级教师"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一级教师",
      "value": "一级教师"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二级教师",
      "value": "二级教师"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三级教师",
      "value": "三级教师"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("曾带奥赛学科:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.aoShuXueKe),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "aoShuXueKe", $$v)
      },
      expression: "eduInfo.aoShuXueKe"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "无"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "数学",
      "value": "数学"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "物理",
      "value": "物理"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "化学",
      "value": "化学"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "生物",
      "value": "生物"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "信息技术",
      "value": "信息技术"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("教师资格证类型:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "必选",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.teacherCertificateType),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "teacherCertificateType", $$v)
      },
      expression: "eduInfo.teacherCertificateType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "无"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "幼儿园教师资格证",
      "value": "幼儿园教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小学教师资格证",
      "value": "小学园教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "初级中学教师资格证",
      "value": "初级中学教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "高级中学教师资格证",
      "value": "高级中学教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "中等职业学校教师资格证",
      "value": "中等职业学校师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "中等职业学校实习指导教师资格证",
      "value": "中等职业学校实习指导教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "高等学校教师资格证",
      "value": "高等学校教师资格证"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "成人/大学教育的教师资格证",
      "value": "成人/大学教育的教师资格证"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("毕业高中:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.gaoZhongSchool),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "gaoZhongSchool", $$v)
      },
      expression: "eduInfo.gaoZhongSchool"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("高考分数:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填",
      "size": "small"
    },
    model: {
      value: (_vm.eduInfo.gaoKaoScore),
      callback: function($$v) {
        _vm.$set(_vm.eduInfo, "gaoKaoScore", $$v)
      },
      expression: "eduInfo.gaoKaoScore"
    }
  })], 1)])])])]), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("工作/实习经历")]), _vm._v(" "), _c('div', {
    staticClass: "create-buttom"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addWorks
    }
  }, [_vm._v("添加经历")])], 1), _vm._v(" "), _vm._l((_vm.workInfos), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "base-info"
    }, [_c('div', {
      staticClass: "base-items"
    }, [_c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("\n                工作单位" + _vm._s(_vm.workInfos.length - index) + ":\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "size": "small",
        "placeholder": "必填"
      },
      model: {
        value: (item.company),
        callback: function($$v) {
          _vm.$set(item, "company", $$v)
        },
        expression: "item.company"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("开始日期:")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "必填",
        "size": "small"
      },
      model: {
        value: (item.startTime),
        callback: function($$v) {
          _vm.$set(item, "startTime", $$v)
        },
        expression: "item.startTime"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("结束日期:")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "必填",
        "size": "small"
      },
      model: {
        value: (item.endTime),
        callback: function($$v) {
          _vm.$set(item, "endTime", $$v)
        },
        expression: "item.endTime"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("工作岗位:")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "必填",
        "size": "small"
      },
      model: {
        value: (item.gangWei),
        callback: function($$v) {
          _vm.$set(item, "gangWei", $$v)
        },
        expression: "item.gangWei"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("工作职位:")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "必填",
        "size": "small"
      },
      model: {
        value: (item.zhiWei),
        callback: function($$v) {
          _vm.$set(item, "zhiWei", $$v)
        },
        expression: "item.zhiWei"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }, [_vm._v("工作内容:")]), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "必填",
        "size": "small",
        "type": "textarea"
      },
      model: {
        value: (item.workContent),
        callback: function($$v) {
          _vm.$set(item, "workContent", $$v)
        },
        expression: "item.workContent"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item flex-item"
    }, [_c('div', {
      staticClass: "item-name flex-item"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteWork(item)
        }
      }
    }, [_vm._v("删除")])], 1)])])])])
  }), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("获得奖励")]), _vm._v(" "), _c('div', {
    staticClass: "base-info"
  }, [_c('div', {
    staticClass: "base-items"
  }, [_c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("奖励(级别最高)１:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.jiangLiFirst),
      callback: function($$v) {
        _vm.$set(_vm.reword, "jiangLiFirst", $$v)
      },
      expression: "reword.jiangLiFirst"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("奖励(级别次之)2:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.jiangLiSecond),
      callback: function($$v) {
        _vm.$set(_vm.reword, "jiangLiSecond", $$v)
      },
      expression: "reword.jiangLiSecond"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("奖励(级别次之)3:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.jiangLiThird),
      callback: function($$v) {
        _vm.$set(_vm.reword, "jiangLiThird", $$v)
      },
      expression: "reword.jiangLiThird"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("职务(级别最高)１:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.jobFirst),
      callback: function($$v) {
        _vm.$set(_vm.reword, "jobFirst", $$v)
      },
      expression: "reword.jobFirst"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("职务(级别次之)2:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.jobSecond),
      callback: function($$v) {
        _vm.$set(_vm.reword, "jobSecond", $$v)
      },
      expression: "reword.jobSecond"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("大学期间参与社团:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.reword.daXueSheTuan),
      callback: function($$v) {
        _vm.$set(_vm.reword, "daXueSheTuan", $$v)
      },
      expression: "reword.daXueSheTuan"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "base-info"
  }, [_c('div', {
    staticClass: "base-items"
  }, [_c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("其他奖励:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.reword.otherReward),
      callback: function($$v) {
        _vm.$set(_vm.reword, "otherReward", $$v)
      },
      expression: "reword.otherReward"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("奖励介绍:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.reword.resumeInfo),
      callback: function($$v) {
        _vm.$set(_vm.reword, "resumeInfo", $$v)
      },
      expression: "reword.resumeInfo"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "base-items"
  }, [_c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("其他职务:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.reword.otherJob),
      callback: function($$v) {
        _vm.$set(_vm.reword, "otherJob", $$v)
      },
      expression: "reword.otherJob"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_c('div', {
    staticClass: "item flex-item"
  }, [_c('div', {
    staticClass: "item-name flex-item"
  }, [_vm._v("备注:")]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.reword.remark),
      callback: function($$v) {
        _vm.$set(_vm.reword, "remark", $$v)
      },
      expression: "reword.remark"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "create-buttom",
    staticStyle: {
      "margin": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateResume
    }
  }, [_vm._v("提交投递")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "300px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdc4eb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home2.vue
// module id = 266
// module chunks = 1